import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import styled from "styled-components";
// import TrackingHint from './TrackingHint/TrackingHint'

type Props = {
  children: React.ReactNode;
  className?: string;
  hideNavigation?: boolean;
  noFooter?: boolean;
  headerTransparent?: boolean;
  disableHeaderPadding?: boolean;
  disableAbsoluteFooter?: boolean;
};

const BG = styled.div`
  background: #033147;
  /* background: radial-gradient(circle, #fff 0%, #033147 200%); */
`;

const Layout: React.FC<Props> = ({
  children,
  className,
  hideNavigation,
  noFooter = false,
  headerTransparent = false,
  disableHeaderPadding = false,
  disableAbsoluteFooter = false,
}) => {
  return (
    <div className={`bg-background ${className}`}>
      <BG className={`min-h-screen flex flex-col justify-between`}>
        <Header
          headerTransparent={headerTransparent}
          hideNavigation={hideNavigation}
        />
        <div
          className={`flex flex-col justify-between overflow-x-hidden min-h-fit ${
            !disableHeaderPadding && "pt-20"
          }`}
        >
          <div>{children}</div>
        </div>
        {!noFooter && <Footer />}
      </BG>
      {/* <TrackingHint /> */}
    </div>
  );
};

export default Layout;
